import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getAllModulesByModuleType } from '../../../selectors/modules';
import { ModuleType } from '../../../../types/modules';
import { Props } from '../Custom/Custom';

type StateProps = Pick<Props, 'viewerKeySuffix'>;

type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  // This is used to bust measured cookie cache
  // If any megabox module is added or removed, or width config is changed from
  // 'stretch' to 'fixed' or vice-versa, we need to bust the measured cookie
  // cache and recalculate widths
  const viewerKeySuffix = getAllModulesByModuleType(
    state as any,
    ModuleType.MEGABOX
  )
    .filter(m => !m.moduleMeta?.isNewlyAdded)
    .map(m => m.version)
    .join('-');
  return {
    viewerKeySuffix,
  };
};

export default connect(mapStateToProps);
